import { Button, TextField } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';

export function CategoryForm({ category = {}, onSubmit, loading = false }) {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      name: category.name || '',
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        fullWidth
        label="Category Name"
        {...register('name', { required: 'Category name is required' })}
        error={!!errors.name}
        helperText={errors.name?.message}
        margin="normal"
      />
      <Button
        type="submit"
        variant="contained"
        fullWidth
        color="primary"
        sx={{ mt: 2 }}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </Button>
    </form>
  );
}

export default CategoryForm;